const REVERSE_PROXY_LINK = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';
const MMID_MESSAGE =
  "The MMID is the official state-issued card through California's Department of Public Health program.";
const MMID_IMAGE = `${REVERSE_PROXY_LINK}/images/regulation/default-mmid-card.png`;

export { MMID_MESSAGE, MMID_IMAGE };
